export const AppConfig = {
  name: "local",
  production: false,
  environment: 'LOCAL',
  datasServer: '../../../datas/'
};
// datasServer: './assets/datas/'
// datasServer: '../../../datas/' // << à remettre en place lorsqu'il n'est plus nécessaire de collaborer sur github, idem virer dossier assets/datas
